import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { minimalLoaderStyles } from './minimalLoader.styles';
const MinimalLoader = ({ width, top, animated }) => {
    const styles = minimalLoaderStyles();
    return (_jsx("div", { className: clsx({ [styles.animate]: animated }), style: {
            width: width || '100%',
            fontSize: '30px',
            textAlign: 'center',
            marginTop: top || 0,
        }, children: "..." }, void 0));
};
export default MinimalLoader;
//# sourceMappingURL=MinimalLoader.js.map